import { Switch } from "@headlessui/react";
import { Popover } from "antd";
import { useImageSize } from "react-image-size";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";

import { Menu, MenuItem, MenuItems, Transition } from "@headlessui/react";

import { darcula } from "react-syntax-highlighter/dist/esm/styles/prism";
import {
  CameraOff,
  ChevronDown,
  Milestone,
  MousePointerClick,
  ScanEye,
  SquareArrowDown,
  Combine,
  TextCursorInput,
  Plus,
  View,
} from "lucide-react";
import React, { memo, useState, useEffect, useRef, Fragment } from "react";
import isEqual from "lodash/fp/isEqual";

import { ChevronDownIcon, TrashIcon } from "@heroicons/react/20/solid";
import { Handle } from "./components/TreeItem/TreeItem";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const ImagePreview = ({ screenshotUrl }) => {
  const [dimensions, { loading, error }] = useImageSize(screenshotUrl);
  if (loading) {
    return <div className="text-xs text-gray-500 py-4 px-2">Loading...</div>;
  }
  return (
    <div>
      <img
        style={{
          width: dimensions?.width > 250 ? 250 : dimensions?.width * 0.5,
        }}
        src={screenshotUrl}
      />
    </div>
  );
};
const iconMap = {
  click: <MousePointerClick size={16} strokeWidth={2.25} />,
  extractItemsFromPage: <Combine size={16} strokeWidth={2.25} />,
  waitForSelector: <View size={16} strokeWidth={2.25} />,
  navigate: <Milestone size={16} strokeWidth={2.25} />,
  keydown: <TextCursorInput size={16} strokeWidth={2.25} />,
  change: <TextCursorInput size={16} strokeWidth={2.25} />,
};

export default memo(
  ({
    id,
    data,
    handleProps,
    handleRemove,
    handleAddItem,
    updateDataForNode,
    clone,
  }) => {
    const [collapsed, setCollapsed] = useState(true);
    const [state, setState] = useState({
      selectFromListItems: null,
      loop: false,
      loopVariableName: null,
      selectorType: "xpath",
      imageUrl: null,
      isAutoComplete: false,
      listSelectionQueryVariableName: null,
      xpathSelector: null,
      interactionInstruction: null,
      variableName: null,
      isVariable: null,
      parentContainerSelector: null,
    });

    const addNodeToTree = (currentInteractionData) => {
      handleAddItem(
        {
          children: [],
          id: "AutoGenerated",
          data: {
            windowType: currentInteractionData.windowType,

            interactionDescription: "Wait for element to appear",
            type: "waitForSelector",
          },
        },
        id
      );
    };
    const useDeepCompareEffect = (callback, dependencies) => {
      const currentDependenciesRef = useRef();
      if (!isEqual(currentDependenciesRef.current, dependencies)) {
        currentDependenciesRef.current = dependencies;
      }
      useEffect(callback, [currentDependenciesRef.current]);
    };

    useEffect(() => {
      if (data && data.xpath) {
        setState({ ...state, xpathSelector: data.xpath });
      }
    }, [data]);

    useDeepCompareEffect(() => {
      console.log({ data }, id, state);
      if (updateDataForNode && !clone) {
        updateDataForNode(id, { ...data, ...state });
      }
    }, [state]);

    return (
      <>
        <div className="w-full">
          <div className="flex items-center justify-between px-4 py-2">
            <div className="flex items-center space-x-2">
              <div className="opacity-20">
                <Handle {...handleProps} />
              </div>

              {iconMap[data?.type]}
              <h1 className="font-semibold text-sm text-auto-white truncate flex-1">
                {data.interactionDescription
                  ? data?.interactionDescription?.charAt(0).toUpperCase() +
                    data?.interactionDescription?.slice(1)
                  : data?.type?.charAt(0).toUpperCase() + data?.type?.slice(1)}
              </h1>
              <div
                className="cursor-pointer"
                onClick={() => setCollapsed(!collapsed)}
              >
                <ChevronDown size={14} strokeWidth={2.6} />
              </div>
            </div>
            <div className="flex items-center space-x-3">
              {data.windowType == "popup" && (
                <div
                  style={{ fontSize: 10 }}
                  className="rounded-full text-auto-dark font-semibold bg-purple-300 px-2 py-0.5"
                >
                  Popup
                </div>
              )}
              {data.screenshotUrl ? (
                <Popover
                  content={<ImagePreview screenshotUrl={data.screenshotUrl} />}
                >
                  <div className="cursor-pointer">
                    <ScanEye size={15} />
                  </div>
                </Popover>
              ) : (
                <div className="opacity-20">
                  <CameraOff size={15} />
                </div>
              )}

              <div
                onClick={() => handleRemove(id)}
                className="bg-auto-light cursor-pointer text-auto-white hover:text-white hover:bg-red-500 rounded-full p-2"
              >
                <TrashIcon className="w-3" />
              </div>
            </div>
          </div>

          {!collapsed && (
            <div className=" bg-black bg-opacity-10 border-auto-light">
              {data.type == "extractItemsFromPage" && (
                <div
                  style={{ maxHeight: 240, overflow: "scroll" }}
                  className="bg-black bg-opacity-10 border-auto-light"
                >
                  <SyntaxHighlighter
                    customStyle={{
                      backgroundColor: "rgba(0,0,0,0)",
                      fontSize: 12,
                    }}
                    language="javascript"
                    style={darcula}
                  >
                    {data.sampleData.slice(0, 5000)}
                    <br />
                    ... Truncated
                  </SyntaxHighlighter>
                </div>
              )}
              <div className="">
                <div className="">
                  <div className="divide-y divide-opacity-40 divide-auto-light">
                    {data.type == "waitForSelector" && (
                      <div className="w-full px-2 py-2">
                        <input
                          type="text"
                          name="loopvariable"
                          id="loopVariableName-input"
                          value={state.loopVariableName}
                          onChange={(e) =>
                            setState({
                              ...state,
                              loopVariableName: e.target.value,
                            })
                          }
                          className="inline-block  bg-auto-dark flex-1 w-full rounded-md border-0 py-0.5 text-auto-white shadow-sm ring-1 ring-inset ring-auto-mid placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-xs sm:leading-6"
                          placeholder="Specify the element you want to wait for "
                        />
                      </div>
                    )}

                    {data.type !== "waitForSelector" && (
                      <div className="flex w-full pr-2 items-center justify-between">
                        <Switch.Group
                          as="div"
                          className="flex items-center px-4 py-3"
                        >
                          <Switch
                            checked={state.loop}
                            onChange={(value) =>
                              setState({
                                ...state,
                                // if we're setting loop to false then set variable name to null
                                loopVariableName: state.loop && null,
                                loop: state.loop ? false : true,
                                isVariable: !state.loop && false,
                                selectFromListItems: !state.loop && false,
                                // if we're setting loop to true then set variable name to null
                                variableName: !state.loop && null,
                              })
                            }
                            className={classNames(
                              state.loop ? "bg-blue-600" : "bg-auto-darkest",
                              "relative inline-flex h-4 w-7 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2"
                            )}
                          >
                            <span
                              aria-hidden="true"
                              className={classNames(
                                state.loop ? "translate-x-3" : "translate-x-0",
                                "pointer-events-none inline-block h-3 w-3 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                              )}
                            />
                          </Switch>
                          <Switch.Label
                            as="div"
                            className="ml-3 items-center w-full flex space-x-3 text-xs"
                          >
                            <span className="font-medium text-auto-white">
                              Start loop
                            </span>{" "}
                          </Switch.Label>
                        </Switch.Group>
                        {state.loop && (
                          <input
                            type="text"
                            name="loopvariable"
                            id="loopVariableName-input"
                            value={state.loopVariableName}
                            onChange={(e) =>
                              setState({
                                ...state,
                                loopVariableName: e.target.value,
                              })
                            }
                            className="inline-block  bg-auto-dark flex-1/2 rounded-md border-0 py-0.5 text-auto-white shadow-sm ring-1 ring-inset ring-auto-mid placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-xs sm:leading-6"
                            placeholder="Variable name for loop"
                          />
                        )}
                      </div>
                    )}

                    {((data?.xpath &&
                      ["click", "change", "input"].includes(data.type)) ||
                      data.type == "extractItemsFromPage") && (
                      <div className="py-3 pr-3 flex justify-between items-center w-full">
                        <Switch.Group
                          as="div"
                          className="flex flex-1 items-center px-4"
                        >
                          <Switch
                            checked={state.selectFromListItems}
                            onChange={(value) =>
                              setState({
                                ...state,
                                isVariable: !state.selectFromListItems && false,
                                loop: !state.selectFromListItems && false,
                                selectFromListItems: value,
                              })
                            }
                            className={classNames(
                              state.selectFromListItems
                                ? "bg-blue-600"
                                : "bg-auto-darkest",
                              "relative inline-flex h-4 w-7 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2"
                            )}
                          >
                            <span
                              aria-hidden="true"
                              className={classNames(
                                state.selectFromListItems
                                  ? "translate-x-3"
                                  : "translate-x-0",
                                "pointer-events-none inline-block h-3 w-3 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                              )}
                            />
                          </Switch>

                          <Switch.Label as="div" className="ml-3 text-xs">
                            <p className="font-medium text-auto-white">
                              Select from list
                            </p>{" "}
                          </Switch.Label>
                          <div className="flex flex-wrap"></div>
                        </Switch.Group>

                        {state?.selectFromListItems && (
                          <div className="space-x-1.5 inline-flex justify-end items-center">
                            <input
                              type="text"
                              name="listQuery"
                              id="listQuery-input"
                              value={state.listSelectionQueryVariableName}
                              onChange={(e) =>
                                setState({
                                  ...state,

                                  listSelectionQueryVariableName:
                                    e.target.value,
                                })
                              }
                              className="inline-block  bg-auto-dark flex-1/2 rounded-md border-0 py-0.5 text-auto-white shadow-sm ring-1 ring-inset ring-auto-mid placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-xs sm:leading-6"
                              placeholder={
                                data.value
                                  ? `User entered ${data.value}`
                                  : "Variable name"
                              }
                            />

                            <Menu
                              as="div"
                              className="relative inline-block text-left"
                            >
                              <div>
                                <Popover
                                  content={
                                    data.parentContainerSelectorScreenshot ? (
                                      <ImagePreview
                                        screenshotUrl={
                                          data.parentContainerSelectorScreenshot
                                        }
                                      />
                                    ) : null
                                  }
                                >
                                  <Menu.Button className="inline-flex truncate w-full justify-center gap-x-1.5 rounded-md bg-auto-light px-3 py-1.5 text-xs font-medium text-auto-white shadow-sm ring-1 ring-inset ring-auto-dark hover:bg-auto-mid">
                                    {data.parentContainerDescription ||
                                      (data?.parentContainerSelector &&
                                        "..." +
                                          data?.parentContainerSelector?.slice(
                                            data.parentContainerSelector
                                              .length - 20,
                                            data.parenContainerSelector
                                          )) ||
                                      "List"}
                                    <ChevronDownIcon
                                      className="-mr-1 h-4 w-4 text-gray-400"
                                      aria-hidden="true"
                                    />
                                  </Menu.Button>
                                </Popover>
                              </div>

                              <Transition
                                as={Fragment}
                                enter="transition ease-out duration-100"
                                enterFrom="transform opacity-0 scale-95"
                                enterTo="transform opacity-100 scale-100"
                                leave="transition ease-in duration-75"
                                leaveFrom="transform opacity-100 scale-100"
                                leaveTo="transform opacity-0 scale-95"
                              >
                                <Menu.Items className="absolute right-0 z-10 w-56  mt-2 origin-top-right rounded-md bg-auto-light shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                  <div className="py-1">
                                    {data.parentSelectors?.map((selector) => (
                                      <Popover
                                        content={
                                          <ImagePreview
                                            screenshotUrl={
                                              selector.screenshotUrl
                                            }
                                          />
                                        }
                                      >
                                        <Menu.Item>
                                          {({ active }) => (
                                            <p
                                              onClick={() =>
                                                setState({
                                                  ...state,
                                                  parentContainerDescription:
                                                    selector.description,
                                                  parentContainerSelectorScreenshot:
                                                    selector.screenshotUrl,
                                                  parentContainerSelector:
                                                    selector.xpath,
                                                })
                                              }
                                              href="#"
                                              className={classNames(
                                                active
                                                  ? "bg-gray-100 bg-opacity-10 text-auto-white"
                                                  : "text-auto-white",
                                                "truncate px-4 py-2 text-xs"
                                              )}
                                            >
                                              {selector.description ||
                                                selector.xpath}
                                            </p>
                                          )}
                                        </Menu.Item>
                                      </Popover>
                                    ))}
                                  </div>
                                </Menu.Items>
                              </Transition>
                            </Menu>
                          </div>
                        )}
                      </div>
                    )}

                    {data.type !== "waitForSelector" &&
                      data.type !== "extractItemsFromPage" && (
                        <div className="flex w-full pr-2 items-center justify-between">
                          <Switch.Group
                            as="div"
                            className="flex items-center px-4 py-3"
                          >
                            <Switch
                              checked={state.isVariable}
                              onChange={(value) =>
                                setState({
                                  ...state,
                                  loop: state.isVariable && false,
                                  selectFromListItems:
                                    !state.isVariable && false,
                                  variableName: state.isVariable
                                    ? null
                                    : state.variableName,
                                  isVariable: state.isVariable ? false : true,
                                })
                              }
                              className={classNames(
                                state.isVariable
                                  ? "bg-blue-600"
                                  : "bg-auto-darkest",
                                "relative inline-flex h-4 w-7 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2"
                              )}
                            >
                              <span
                                aria-hidden="true"
                                className={classNames(
                                  state.isVariable
                                    ? "translate-x-3"
                                    : "translate-x-0",
                                  "pointer-events-none inline-block h-3 w-3 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                                )}
                              />
                            </Switch>
                            <Switch.Label
                              as="div"
                              className="ml-3 items-center w-full flex space-x-3 text-xs"
                            >
                              <span className="font-medium text-auto-white">
                                Variable
                              </span>{" "}
                            </Switch.Label>
                          </Switch.Group>

                          {state.isVariable && (
                            <input
                              type="text"
                              name="variable"
                              id="variableName-input"
                              value={state.variableName}
                              onChange={(e) =>
                                setState({
                                  ...state,
                                  variableName: e.target.value,
                                })
                              }
                              className="inline-block  bg-auto-dark flex-1/2 rounded-md border-0 py-0.5 text-auto-white shadow-sm ring-1 ring-inset ring-auto-mid placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-xs sm:leading-6"
                              placeholder={
                                data.value
                                  ? `User entered ${data.value}`
                                  : "Variable name"
                              }
                            />
                          )}
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div>
          <div
            onClick={() => addNodeToTree(data)}
            style={{ zIndex: 99, marginTop: 8 }}
            className="absolute p-1.5 opacity-0 hover:opacity-100 bg-auto-light cursor-pointer rounded-full border-1 border-auto-dark shadow-sm left-1/2 transform -translate-x-1/2"
          >
            <Plus color="white" size={12} />
          </div>
        </div>
      </>
    );
  }
);
